module.exports = __webpack_public_path__ + "static/media/halo-fix-mobile.0d21e362.svg";